import { SystemThemeEnum } from '../config-provider/types';
export const TRIGGER_FOCUS = 'focus';
export const TRIGGER_CLICK = 'click';
export const TRIGGER_HOVER = 'hover';
export const VUE2 = '2';
export const VUE3 = '3';
export const defaultConfigProvider = {
  teleport: () => document.body,
  theme: SystemThemeEnum.Light
};